import React, { FC } from 'react';

import { Texto } from 'view/component/Tipografia/Texto';
import { OrdemColunaIcone } from 'view/component/Tabela/OrdemColunaIcone';
import { AriaSort, OrdemColunaTabela } from 'view/component/Tabela/model/OrdemColunaTabela';
import { DetalhesFiltro } from './DetalhesFiltro';

import { FiltroResumoItemEsqueleto } from './FiltroResumoItem';

interface FiltroResumoItemOrdemConteudoProps {
  detalhesFiltro: DetalhesFiltro[];
  ordem?: OrdemColunaTabela;
}

interface FiltroResumoItemOrdemProps extends FiltroResumoItemOrdemConteudoProps {
  onRemoverClick: (chave: string) => void;
}


export const FiltroResumoItemOrdem: FC<FiltroResumoItemOrdemProps> = ({onRemoverClick: onRemoverSort, detalhesFiltro, ordem}) => {
  return <FiltroResumoItemEsqueleto<any>
      rotulo="Ordernado por"
      onRemoverClick={onRemoverSort as any}
      identificador="sort">
    <FiltroResumoItemOrdemConteudo detalhesFiltro={detalhesFiltro} ordem={ordem} />
  </FiltroResumoItemEsqueleto>
}


const FiltroResumoItemOrdemConteudo: FC<FiltroResumoItemOrdemConteudoProps> = ({detalhesFiltro, ordem}) => {
  if (ordem === undefined || ordem.ordem === AriaSort.None) {
    return <></>
  }

  const detalhesPorIdentificador: {[key: string]: DetalhesFiltro} = {}

  detalhesFiltro.forEach(it => {
    const identificador = it.identificadorOrdem ?? it.identificador;
    detalhesPorIdentificador[identificador] = it;
  });

  let ordemPortugues: string;
  if (ordem.ordem === AriaSort.Descending) {
    ordemPortugues = 'Descrescente';
  } else {
    ordemPortugues = 'Crescente';
  }

  const rotulo = detalhesPorIdentificador[ordem.coluna]?.rotulo ?? ordem.coluna;

  return <>
    <Texto>{rotulo}</Texto>
    <OrdemColunaIcone ariaSort={ordem.ordem} title={`Ordem aplicada: ${ordemPortugues}`} />
  </>
}
